// extracted by mini-css-extract-plugin
export default {"wrapper":"CompanyInfo_wrapper__EEBqU","left":"CompanyInfo_left__DVs4x"};